<template>
  <div id="xvideo">
    <video
      v-on="$listeners"
      id="my-video"
      class="video-js"
      width="630"
      height="420"
      controls
      :currentTime.prop="this.startframe"
      :src="video"
      type="video/mp4"
    />
  </div>
</template>
<script>
import Xvideojs from "video.js";
export default {
  props: {
    video: {
      type: String,
      required: true,
      default: ""
    },
    first: {
      type: [String, Number],
      required: true,
      default: "20"
    },
    last: {
      type: [String, Number],
      required: true,
      default: "20"
    },
    fps: {
      type: [String, Number],
      required: true,
      default: "20"
    }
  },
  data: function() {
    return {
      player: {},
      startframe: {}
    };
  },
  watch: {
    first: function() {
      this.StartVideo();
    }
    //    first: function(newVal, oldVal) {
    //      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    //      this.StartVideo();
    //    }
  },
  mounted() {
    this.player = Xvideojs.getPlayer(
      this.$refs.videoPlayer,
      this.options,
      function onPlayerReady() {
        this.currentTime(100);
        this.play();
      }
    );
  },
  methods: {
    StartVideo() {
      //this.startframe = Math.floor(this.first / this.fps);
      this.startframe = this.first / this.fps;
      let el = document.getElementById("my-video");
      el.pause();
      let period = (1000 * (this.last - this.first)) / this.fps;
      if (period < 500) period = 550;
    }
  }
};
</script>
<style scoped>
.video-js {
  width: 630px;
  height: 420px;
  width: 315px;
  height: 210px;
  width: 420px;
  height: 280px;
}
</style>
